
<script>
import CancelInsuranceForm from './views/Form.vue'
import addIcon from '@/assets/images/icons/plus.svg?inline'
import removeIcon from '@/assets/images/icons/cancel.svg?inline'

export default {
  name: 'cart-cancel-insurance',
  components: {
    CancelInsuranceForm,
    addIcon,
    removeIcon
  },
  data: () => ({
    active: false,
    resultIsShown: false
  }),
  computed: {
    cancelInsurances() {
      return this.$store.getters['cart/getInsurances']
    },
  },
  methods: {
    insuranceIsSelect(insurance) {
      return insurance.insurances.current.slug !== null && !insurance.form.ages.includes(null)
    },
    addCancelInsurance() {
      this.active = true
      this.$store.commit('cart/setCancelInsuranceInitial')
    },
    removedForm() {
      this.active = false
      this.$store.commit('cart/clearCancelInsuranceState')
    }
  }
}
</script>

<template>
  <div
    v-if="cancelInsurances.length"
    class="cart__services--item"
  >
    <div
      v-if="!active"
      class="cart__item-header cart__item-header--empty"
    >
      <h3>Страховка от невыезда</h3>
      <div class="cart__item-header--row-btn">
        <div
          class="cart__item-header--btn"
          @click="addCancelInsurance"
        >
          <addIcon
            fill="#ffffff"
          />
          <span>добавить</span>
        </div>
      </div>
    </div>
    <div
      v-if="active"
      class="cart__item-header"
    >
      <h3>Страховка от невыезда</h3>
      <div class="cart__item-header--row-btn">
        <div
          class="cart__item-header--btn"
          @click="removedForm"
        >
          <removeIcon
            fill="#ffffff"
          />
          <span>удалить</span>
        </div>
      </div>
    </div>
    <div
      v-if="active"
    >
      <div
        v-for="(cancelInsurance, cancelInsuranceIndex) in cancelInsurances"
        :key="cancelInsuranceIndex"
        class="cart__main"
      >
        <div class="cart__item-content">
          <h2
            v-if="!insuranceIsSelect(cancelInsurance)"
            class="cart__error"
          >
            Для выбора страховки от невыезда, требуется медицинская страховка у всех туристов.
          </h2>
          <cancel-insurance-form
            v-if="insuranceIsSelect(cancelInsurance)"
            :cancel-insurance-index="cancelInsuranceIndex"
          />
        </div>
      </div>
    </div>
  </div>
</template>
